import React from "react";
import ListGroup from "react-bootstrap/ListGroup";

const DocumentTypesTable = ({ data, setItem }) => {
  return (
    <ListGroup as='ol' variant='flush'>
      {data.map((item) => (
        <ListGroup.Item as='li' key={item.value} action>
          {item.label}
          <span className='hyperlink float-end' onClick={() => setItem(item)}>
            Edit
          </span>
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
};

export default DocumentTypesTable;
